export default __webpack_public_path__ + "static/media/dta_2.2bb70e54.png";